module.exports = __webpack_public_path__ + "static/media/49.ee1913c2.png";